import React from "react";
import _ from "lodash";
import ModalWrapper from "components/common/ModalWrapper";
import SimpleDataTable from "components/common/SimpleDataTable";
import DateTimeFormatter from "components/common/DateTimeFormatter";
import { buttonActionClassGray } from "helpers/StyleClass";

import { FiInfo } from "react-icons/fi";

class PackageVersionButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  render() {
    const { data, networkInfo } = this.props;
    const { isOpen } = this.state;

    return (
      <>
        <button
          className={buttonActionClassGray}
          onClick={() => this.setState({ isOpen: true })}
        >
          Version History
        </button>
        {isOpen && (
          <PackageVersionModal
            handleClose={() => this.setState({ isOpen: false })}
            data={data}
            networkInfo={networkInfo}
          ></PackageVersionModal>
        )}
      </>
    );
  }
}

class PackageVersionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      moreInfoVersion: null,
    };
  }

  render() {
    const { handleClose, data, networkInfo } = this.props;
    const { moreInfoVersion } = this.state;

    const sortedVersions = _.orderBy(data.versions, ["version"], ["desc"]).map(
      (d) => ({
        ...d,
        parsedReleaseNotes: (
          <pre className="whitespace-pre-wrap text-xs">{d.releaseNotes}</pre>
        ),
        parsedCreatedAt: (
          <DateTimeFormatter
            datetime={d.createdAt}
            timezone={networkInfo.timezone}
            place="right"
          ></DateTimeFormatter>
        ),
        more: (
          <button
            className="text-blue-600"
            onClick={() => this.setState({ moreInfoVersion: d })}
          >
            <FiInfo></FiInfo>
          </button>
        ),
      })
    );

    return (
      <>
        <ModalWrapper
          isOpen={true}
          showCloseFooter={true}
          handleClose={handleClose}
          customOverlayStyle={{ zIndex: 100 }}
          title={{
            label: "Version History ",
            highlight: data.packageName,
          }}
          width="800px"
        >
          <div className="overflow-y-auto pr-6" style={{ maxHeight: "500px" }}>
            <div className="w-full text-right text-xs text-gray-600">
              {sortedVersions.length} items
            </div>
            <SimpleDataTable
              items={sortedVersions}
              columns={[
                { label: "Ver.", key: "version" },
                {
                  label: "Created At",
                  key: "parsedCreatedAt",
                  className: "w-48",
                },
                {
                  label: "Release Notes",
                  key: "parsedReleaseNotes",
                  style: { textAlign: "left" },
                },
                { label: "", key: "more" },
              ]}
            />
          </div>
        </ModalWrapper>

        {moreInfoVersion && (
          <ModalWrapper
            isOpen={true}
            showCloseFooter={true}
            handleClose={() => this.setState({ moreInfoVersion: null })}
            customOverlayStyle={{ zIndex: 101 }}
            title="Information of Version"
            width="860px"
          >
            <div
              className="flex overflow-y-auto pr-6"
              style={{ height: "360px" }}
            >
              <div className="w-1/2">
                <LabelContent label="Version" value={moreInfoVersion.version} />
                <LabelContent label="Created At">
                  <DateTimeFormatter
                    datetime={moreInfoVersion.createdAt}
                    timezone={networkInfo.timezone}
                    place="right"
                  />
                </LabelContent>
                <LabelContent label="Git Tag">
                  <div className="text-sm text-gray-800">
                    {moreInfoVersion.gitTag}
                  </div>
                </LabelContent>
                <LabelContent
                  label={`File Templates (${moreInfoVersion.fileTemplates.length})`}
                  value={moreInfoVersion.fileTemplates}
                />
                <LabelContent
                  label={`Middlewares (${moreInfoVersion.middlewares.length})`}
                  value={moreInfoVersion.middlewares}
                />
              </div>
              <div className="w-1/2">
                <LabelContent label="Release Notes">
                  <pre className="rounded whitespace-pre-wrap bg-gray-200 p-2 text-xs">
                    {moreInfoVersion.releaseNotes}
                  </pre>
                </LabelContent>
                <LabelContent
                  label={`Post Middlewares (${moreInfoVersion.postMiddlewares.length})`}
                >
                  <div className="mb-3 flex flex-col gap-2 text-gray-800">
                    {moreInfoVersion.postMiddlewares.map((item, idx) => (
                      <div
                        className="rounded border border-gray-300 px-2 pt-2"
                        key={idx}
                      >
                        <LabelContent
                          label={`File Patterns (${item.filenamePatterns.length})`}
                          value={item.filenamePatterns}
                        />
                        <LabelContent label="Method">
                          <div className="text-sm text-gray-800">
                            {item.method}
                          </div>
                        </LabelContent>
                        <LabelContent
                          label="Parameters"
                          value={item.parameters}
                        />
                      </div>
                    ))}
                  </div>
                </LabelContent>
              </div>
            </div>
          </ModalWrapper>
        )}
      </>
    );
  }
}

function LabelContent({ label, value, children }) {
  let contentElement = null;
  if (typeof value === "string" || typeof value === "number") {
    contentElement = <div className="text-gray-800">{value}</div>;
  } else if (_.isArray(value)) {
    contentElement = (
      <div className="flex flex-wrap gap-2">
        {value.map((d) => (
          <div
            className="border rounded bg-gray-100 px-2 text-sm"
            key={`${label}-${d}`}
          >
            {d}
          </div>
        ))}
      </div>
    );
  } else if (_.isObject(value)) {
    contentElement = (
      <pre className="rounded whitespace-pre-wrap bg-gray-200 p-1 text-xs">
        {JSON.stringify(value, null, 2)}
      </pre>
    );
  }

  return (
    <div className="mb-2">
      <div className="text-sm leading-4 text-gray-600">{label}</div>
      {contentElement || children || ""}
    </div>
  );
}

export default PackageVersionButton;
